import { call } from 'redux-saga/effects';
import { signalingAnswerDeleted } from 'features/qa/actions';
import { cleanupQANotificationsSaga } from './cleanupQANotificationsSaga';

export function* onAnswerDeletedSaga(action: ReturnType<typeof signalingAnswerDeleted>) {
  yield call(cleanupQANotificationsSaga, action.payload.id);
}
